import React from 'react';
import ReactDOM from 'react-dom';

import { mobileNav } from "./mobileNav.js";
import { adjustHeight } from "./adjustHeight.js";
import { carousel } from "./carousel.js";
import { primaryNavigation } from "./primaryNavigation.js";

import { headerSearch } from "./headerSearch.js";
import { SearchPage } from "./search.jsx";

const searchClass = document.querySelectorAll('.search-wrapper')

mobileNav();
adjustHeight();
carousel();
primaryNavigation()
headerSearch();

if (searchClass.length > 0) {
  const root = ReactDOM.createRoot(document.getElementById("search-wrapper"))
  root.render(<SearchPage itemsPerPage={10} type="" data='https://dxp-au-search.funnelback.squiz.cloud/s/search.json' />)
}

// Dynamically import the profileGrid module when needed.
var profileGridElement = document.getElementById("profile-grid");
if (profileGridElement) {
    import('./profileGrid.js?v=1.2')
        .then(module => {
            // Execute the profileGrid function from the imported module
            module.profileGrid();
        })
        .catch(error => {
            console.error('Failed to load the profileGrid module', error);
        });
}

// Dynamically import the Video modal when needed.
var videoElement = document.getElementById("feature-video");
if (videoElement) {
    import('./videoModal.js')
        .then(module => {
            // Execute the profileGrid function from the imported module
            module.videoModal();
        })
        .catch(error => {
            console.error('Failed to load the profileGrid module', error);
        });
}


//Auto add scroll feature to internal links that use a hash
const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach(anchor => {
    anchor.addEventListener("click", function (e) {
    // Get the href attribute value
    const href = this.getAttribute("href");

    // If the href is exactly "#", scroll to the top of the page
    if (href === "#") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
    }

    // Find the target element on the page
    const targetElement = document.querySelector(href);
    if (targetElement) {
        e.preventDefault(); // Prevent the default jump-to behavior
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    });
});